export type Department = {
  departmentId: number;
  departmentName: string;
  locationId: number;
  managerId: number;
  startDate: string;
  employeeCount: number;
  type: string;
  currency: string;
  primary: string[];
  rating: number;
  targetComplete: number;
};

export const departmentData = [
  {
    departmentId: 10,
    departmentName: 'Finance 9',
    locationId: 300,
    managerId: 7001,
    startDate: '2014-06-13',
    employeeCount: 335,
    type: 'Sales',
    currency: 'EUR',
    primary: [],
    rating: 3,
    targetComplete: 90
  },
  {
    departmentId: 20,
    departmentName: 'Control And Credit 9',
    locationId: 300,
    managerId: 7001,
    startDate: '2019-09-10',
    employeeCount: 206,
    type: 'HR',
    currency: 'USD',
    primary: [],
    rating: 1,
    targetComplete: 90
  },
  {
    departmentId: 30,
    departmentName: 'Purchasing 28',
    locationId: 400,
    managerId: 6001,
    startDate: '2021-01-03',
    employeeCount: 473,
    type: 'HR',
    currency: 'JPY',
    primary: ['checked'],
    rating: 3,
    targetComplete: 50
  },
  {
    departmentId: 40,
    departmentName: 'Purchasing 27',
    locationId: 400,
    managerId: 1001,
    startDate: '2016-02-01',
    employeeCount: 369,
    type: 'Finance',
    currency: 'JPY',
    primary: [],
    rating: 5,
    targetComplete: 80
  },
  {
    departmentId: 50,
    departmentName: 'Shipping 4',
    locationId: 300,
    managerId: 2001,
    startDate: '2014-07-31',
    employeeCount: 476,
    type: 'HR',
    currency: 'EUR',
    primary: [],
    rating: 2,
    targetComplete: 90
  },
  {
    departmentId: 60,
    departmentName: 'Finance 10',
    locationId: 400,
    managerId: 5001,
    startDate: '2017-01-17',
    employeeCount: 304,
    type: 'Sales',
    currency: 'JPY',
    primary: ['checked'],
    rating: 3,
    targetComplete: 80
  },
  {
    departmentId: 70,
    departmentName: 'Operations 9',
    locationId: 400,
    managerId: 6001,
    startDate: '2015-05-24',
    employeeCount: 334,
    type: 'Sales',
    currency: 'EUR',
    primary: [],
    rating: 2,
    targetComplete: 60
  },
  {
    departmentId: 80,
    departmentName: 'Sales and Marketing 18',
    locationId: 500,
    managerId: 4001,
    startDate: '2017-03-25',
    employeeCount: 211,
    type: 'Finance',
    currency: 'JPY',
    primary: [],
    rating: 1,
    targetComplete: 70
  },
  {
    departmentId: 90,
    departmentName: 'Inventory 6',
    locationId: 400,
    managerId: 5001,
    startDate: '2017-12-18',
    employeeCount: 429,
    type: 'Finance',
    currency: 'EUR',
    primary: ['checked'],
    rating: 1,
    targetComplete: 70
  },
  {
    departmentId: 100,
    departmentName: 'Billing 22',
    locationId: 400,
    managerId: 6001,
    startDate: '2014-06-26',
    employeeCount: 219,
    type: 'Sales',
    currency: 'EUR',
    primary: ['checked'],
    rating: 3,
    targetComplete: 80
  },
  {
    departmentId: 110,
    departmentName: 'Finance 1',
    locationId: 100,
    managerId: 3001,
    startDate: '2020-02-12',
    employeeCount: 412,
    type: 'Finance',
    currency: 'USD',
    primary: ['checked'],
    rating: 5,
    targetComplete: 70
  },
  {
    departmentId: 120,
    departmentName: 'Sales and Marketing 28',
    locationId: 300,
    managerId: 2001,
    startDate: '2014-07-11',
    employeeCount: 373,
    type: 'HR',
    currency: 'USD',
    primary: ['checked'],
    rating: 5,
    targetComplete: 60
  },
  {
    departmentId: 130,
    departmentName: 'Operations 22',
    locationId: 300,
    managerId: 1001,
    startDate: '2015-05-26',
    employeeCount: 245,
    type: 'Marketing',
    currency: 'USD',
    primary: [],
    rating: 2,
    targetComplete: 80
  },
  {
    departmentId: 140,
    departmentName: 'Human Resources 22',
    locationId: 200,
    managerId: 1001,
    startDate: '2015-09-08',
    employeeCount: 217,
    type: 'Finance',
    currency: 'USD',
    primary: [],
    rating: 5,
    targetComplete: 70
  },
  {
    departmentId: 150,
    departmentName: 'Shipping 17',
    locationId: 300,
    managerId: 6001,
    startDate: '2017-10-04',
    employeeCount: 441,
    type: 'HR',
    currency: 'USD',
    primary: ['checked'],
    rating: 5,
    targetComplete: 60
  },
  {
    departmentId: 160,
    departmentName: 'Administration 8',
    locationId: 400,
    managerId: 2001,
    startDate: '2014-12-21',
    employeeCount: 332,
    type: 'HR',
    currency: 'USD',
    primary: [],
    rating: 2,
    targetComplete: 60
  },
  {
    departmentId: 170,
    departmentName: 'Purchasing 14',
    locationId: 400,
    managerId: 4001,
    startDate: '2019-01-25',
    employeeCount: 282,
    type: 'Marketing',
    currency: 'EUR',
    primary: [],
    rating: 2,
    targetComplete: 70
  },
  {
    departmentId: 180,
    departmentName: 'Operations 13',
    locationId: 400,
    managerId: 2001,
    startDate: '2016-01-18',
    employeeCount: 336,
    type: 'Finance',
    currency: 'EUR',
    primary: ['checked'],
    rating: 4,
    targetComplete: 90
  },
  {
    departmentId: 190,
    departmentName: 'Control And Credit 18',
    locationId: 100,
    managerId: 1001,
    startDate: '2014-03-11',
    employeeCount: 391,
    type: 'Sales',
    currency: 'JPY',
    primary: [],
    rating: 4,
    targetComplete: 50
  },
  {
    departmentId: 200,
    departmentName: 'Purchasing 10',
    locationId: 200,
    managerId: 7001,
    startDate: '2014-02-06',
    employeeCount: 211,
    type: 'Sales',
    currency: 'JPY',
    primary: [],
    rating: 4,
    targetComplete: 80
  },
  {
    departmentId: 210,
    departmentName: 'Finance 2',
    locationId: 100,
    managerId: 5001,
    startDate: '2014-01-29',
    employeeCount: 239,
    type: 'Finance',
    currency: 'EUR',
    primary: ['checked'],
    rating: 1,
    targetComplete: 50
  },
  {
    departmentId: 220,
    departmentName: 'Administration 4',
    locationId: 300,
    managerId: 6001,
    startDate: '2014-08-15',
    employeeCount: 355,
    type: 'Marketing',
    currency: 'EUR',
    primary: ['checked'],
    rating: 4,
    targetComplete: 50
  },
  {
    departmentId: 230,
    departmentName: 'Human Resources 6',
    locationId: 300,
    managerId: 6001,
    startDate: '2020-03-14',
    employeeCount: 385,
    type: 'Marketing',
    currency: 'EUR',
    primary: [],
    rating: 1,
    targetComplete: 60
  },
  {
    departmentId: 240,
    departmentName: 'Control And Credit 24',
    locationId: 200,
    managerId: 7001,
    startDate: '2015-04-25',
    employeeCount: 355,
    type: 'HR',
    currency: 'USD',
    primary: [],
    rating: 3,
    targetComplete: 90
  },
  {
    departmentId: 250,
    departmentName: 'Control And Credit 8',
    locationId: 200,
    managerId: 6001,
    startDate: '2020-11-17',
    employeeCount: 361,
    type: 'Marketing',
    currency: 'USD',
    primary: ['checked'],
    rating: 1,
    targetComplete: 80
  },
  {
    departmentId: 260,
    departmentName: 'Billing 21',
    locationId: 200,
    managerId: 5001,
    startDate: '2018-05-18',
    employeeCount: 467,
    type: 'Finance',
    currency: 'EUR',
    primary: [],
    rating: 4,
    targetComplete: 90
  },
  {
    departmentId: 270,
    departmentName: 'Administration 5',
    locationId: 400,
    managerId: 3001,
    startDate: '2016-07-09',
    employeeCount: 495,
    type: 'Marketing',
    currency: 'USD',
    primary: [],
    rating: 1,
    targetComplete: 80
  },
  {
    departmentId: 280,
    departmentName: 'Purchasing 27',
    locationId: 100,
    managerId: 1001,
    startDate: '2017-01-20',
    employeeCount: 364,
    type: 'Finance',
    currency: 'JPY',
    primary: [],
    rating: 1,
    targetComplete: 60
  },
  {
    departmentId: 290,
    departmentName: 'Human Resources 24',
    locationId: 200,
    managerId: 6001,
    startDate: '2020-03-03',
    employeeCount: 242,
    type: 'Marketing',
    currency: 'USD',
    primary: ['checked'],
    rating: 5,
    targetComplete: 90
  },
  {
    departmentId: 300,
    departmentName: 'Finance 23',
    locationId: 300,
    managerId: 1001,
    startDate: '2020-09-20',
    employeeCount: 327,
    type: 'Finance',
    currency: 'EUR',
    primary: [],
    rating: 3,
    targetComplete: 60
  },
  {
    departmentId: 310,
    departmentName: 'Inventory 24',
    locationId: 500,
    managerId: 3001,
    startDate: '2015-07-18',
    employeeCount: 420,
    type: 'Finance',
    currency: 'JPY',
    primary: [],
    rating: 5,
    targetComplete: 70
  },
  {
    departmentId: 320,
    departmentName: 'Shipping 26',
    locationId: 400,
    managerId: 1001,
    startDate: '2015-09-16',
    employeeCount: 219,
    type: 'Sales',
    currency: 'EUR',
    primary: [],
    rating: 3,
    targetComplete: 60
  },
  {
    departmentId: 330,
    departmentName: 'Inventory 22',
    locationId: 200,
    managerId: 5001,
    startDate: '2014-11-22',
    employeeCount: 356,
    type: 'HR',
    currency: 'EUR',
    primary: [],
    rating: 2,
    targetComplete: 90
  },
  {
    departmentId: 340,
    departmentName: 'Purchasing 4',
    locationId: 300,
    managerId: 6001,
    startDate: '2014-03-02',
    employeeCount: 202,
    type: 'HR',
    currency: 'USD',
    primary: [],
    rating: 3,
    targetComplete: 50
  },
  {
    departmentId: 350,
    departmentName: 'Purchasing 9',
    locationId: 400,
    managerId: 7001,
    startDate: '2020-06-09',
    employeeCount: 415,
    type: 'Finance',
    currency: 'USD',
    primary: ['checked'],
    rating: 2,
    targetComplete: 70
  },
  {
    departmentId: 360,
    departmentName: 'Purchasing 14',
    locationId: 300,
    managerId: 1001,
    startDate: '2020-07-20',
    employeeCount: 323,
    type: 'HR',
    currency: 'JPY',
    primary: ['checked'],
    rating: 5,
    targetComplete: 70
  },
  {
    departmentId: 370,
    departmentName: 'Operations 4',
    locationId: 500,
    managerId: 6001,
    startDate: '2015-08-23',
    employeeCount: 473,
    type: 'HR',
    currency: 'USD',
    primary: [],
    rating: 5,
    targetComplete: 80
  },
  {
    departmentId: 380,
    departmentName: 'Sales and Marketing 26',
    locationId: 500,
    managerId: 1001,
    startDate: '2017-08-02',
    employeeCount: 380,
    type: 'Finance',
    currency: 'EUR',
    primary: [],
    rating: 3,
    targetComplete: 60
  },
  {
    departmentId: 390,
    departmentName: 'Control And Credit 12',
    locationId: 200,
    managerId: 1001,
    startDate: '2017-10-08',
    employeeCount: 328,
    type: 'Sales',
    currency: 'USD',
    primary: [],
    rating: 2,
    targetComplete: 60
  },
  {
    departmentId: 400,
    departmentName: 'Sales and Marketing 6',
    locationId: 300,
    managerId: 7001,
    startDate: '2019-02-06',
    employeeCount: 301,
    type: 'Marketing',
    currency: 'USD',
    primary: [],
    rating: 2,
    targetComplete: 50
  },
  {
    departmentId: 410,
    departmentName: 'Administration 3',
    locationId: 400,
    managerId: 3001,
    startDate: '2020-07-09',
    employeeCount: 250,
    type: 'Finance',
    currency: 'USD',
    primary: ['checked'],
    rating: 2,
    targetComplete: 50
  },
  {
    departmentId: 420,
    departmentName: 'Finance 18',
    locationId: 400,
    managerId: 6001,
    startDate: '2017-08-07',
    employeeCount: 409,
    type: 'Marketing',
    currency: 'USD',
    primary: [],
    rating: 1,
    targetComplete: 90
  },
  {
    departmentId: 430,
    departmentName: 'Operations 11',
    locationId: 400,
    managerId: 3001,
    startDate: '2015-09-24',
    employeeCount: 296,
    type: 'Marketing',
    currency: 'USD',
    primary: ['checked'],
    rating: 3,
    targetComplete: 80
  },
  {
    departmentId: 440,
    departmentName: 'Inventory 6',
    locationId: 300,
    managerId: 4001,
    startDate: '2016-05-27',
    employeeCount: 467,
    type: 'HR',
    currency: 'EUR',
    primary: ['checked'],
    rating: 3,
    targetComplete: 70
  },
  {
    departmentId: 450,
    departmentName: 'Inventory 27',
    locationId: 300,
    managerId: 4001,
    startDate: '2019-05-29',
    employeeCount: 244,
    type: 'HR',
    currency: 'JPY',
    primary: ['checked'],
    rating: 1,
    targetComplete: 90
  },
  {
    departmentId: 460,
    departmentName: 'Transportation 8',
    locationId: 400,
    managerId: 6001,
    startDate: '2018-08-23',
    employeeCount: 443,
    type: 'Finance',
    currency: 'EUR',
    primary: [],
    rating: 2,
    targetComplete: 80
  },
  {
    departmentId: 470,
    departmentName: 'Inventory 21',
    locationId: 300,
    managerId: 5001,
    startDate: '2015-01-20',
    employeeCount: 250,
    type: 'Sales',
    currency: 'JPY',
    primary: [],
    rating: 1,
    targetComplete: 50
  },
  {
    departmentId: 480,
    departmentName: 'Finance 14',
    locationId: 300,
    managerId: 7001,
    startDate: '2014-09-24',
    employeeCount: 319,
    type: 'Marketing',
    currency: 'USD',
    primary: ['checked'],
    rating: 5,
    targetComplete: 50
  },
  {
    departmentId: 490,
    departmentName: 'Human Resources 12',
    locationId: 300,
    managerId: 5001,
    startDate: '2019-06-29',
    employeeCount: 448,
    type: 'HR',
    currency: 'JPY',
    primary: [],
    rating: 2,
    targetComplete: 70
  },
  {
    departmentId: 500,
    departmentName: 'Transportation 29',
    locationId: 300,
    managerId: 5001,
    startDate: '2014-01-07',
    employeeCount: 453,
    type: 'HR',
    currency: 'EUR',
    primary: ['checked'],
    rating: 3,
    targetComplete: 80
  }
];

export type Employee = {
  id: string;
  name: string;
  title: string;
  initial: string;
};

export const employeeData: Employee[] = [
  {
    id: '3',
    name: 'Chris Benalamore',
    title: 'Area Business Operations Director EMEA & JAPAC',
    initial: 'CB'
  },
  {
    id: '1',
    name: 'Chris Black',
    title: 'Oracle Cloud Infrastructure GTM Channel Director EMEA',
    initial: 'CB'
  },
  {
    id: '2',
    name: 'Christine Cooper',
    title: 'Senior Principal Escalation Manager',
    initial: 'CC'
  },
  {
    id: '4',
    name: 'Christopher Johnson',
    title: 'Vice-President HCM Application Development',
    initial: 'CJ'
  },
  {
    id: '6',
    name: 'Kurt Marchris',
    title: 'Customer Service Analyst',
    initial: 'KM'
  },
  {
    id: '5',
    name: 'Samire Christian',
    title: 'Consulting Project Technical Manager',
    initial: 'SC'
  },
  {
    id: '7',
    name: 'Zelda Christian Cooperman',
    title: 'Senior Principal Escalation Manager 2',
    initial: 'ZC'
  }
];

export type EmployeeStatus = {
  employeeId: number;
  firstName: string;
  lastName: string;
  revenue: number;
  targetComplete: number;
  targetIncomplete: number;
  rating: number;
  status: string;
  salary: number;
  bonus: number;
  departmentId: number;
};

export const employeeStatusData = [
  {
    employeeId: 10,
    firstName: 'Frank',
    lastName: 'Stout',
    revenue: 33200,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 5,
    status: 'Pending',
    salary: 159000,
    bonus: 47900,
    departmentId: 320
  },
  {
    employeeId: 20,
    firstName: 'Mara',
    lastName: 'Rivers',
    revenue: 17200,
    targetComplete: 40,
    targetIncomplete: 60,
    rating: 3,
    status: 'Pending',
    salary: 200000,
    bonus: 45300,
    departmentId: 40
  },
  {
    employeeId: 30,
    firstName: 'Karina',
    lastName: 'Cameron',
    revenue: 30100,
    targetComplete: 30,
    targetIncomplete: 70,
    rating: 4,
    status: 'Approved',
    salary: 279000,
    bonus: 79700,
    departmentId: 370
  },
  {
    employeeId: 40,
    firstName: 'Marilyn',
    lastName: 'Short',
    revenue: 48800,
    targetComplete: 90,
    targetIncomplete: 10,
    rating: 3,
    status: 'Approved',
    salary: 106000,
    bonus: 77500,
    departmentId: 310
  },
  {
    employeeId: 50,
    firstName: 'Audra',
    lastName: 'Long',
    revenue: 40700,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 4,
    status: 'Pending',
    salary: 123000,
    bonus: 39900,
    departmentId: 490
  },
  {
    employeeId: 60,
    firstName: 'Woods',
    lastName: 'Jefferson',
    revenue: 29000,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 3,
    status: 'Pending',
    salary: 145000,
    bonus: 49600,
    departmentId: 160
  },
  {
    employeeId: 70,
    firstName: 'Spears',
    lastName: 'Howe',
    revenue: 32900,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 5,
    status: 'Approved',
    salary: 120000,
    bonus: 30300,
    departmentId: 460
  },
  {
    employeeId: 80,
    firstName: 'Kelsey',
    lastName: 'Gomez',
    revenue: 34200,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 1,
    status: 'Pending',
    salary: 147000,
    bonus: 79800,
    departmentId: 330
  },
  {
    employeeId: 90,
    firstName: 'Miriam',
    lastName: 'Branch',
    revenue: 42800,
    targetComplete: 90,
    targetIncomplete: 10,
    rating: 3,
    status: 'Pending',
    salary: 117000,
    bonus: 43000,
    departmentId: 50
  },
  {
    employeeId: 100,
    firstName: 'Tisha',
    lastName: 'Parks',
    revenue: 17800,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 1,
    status: 'Pending',
    salary: 136000,
    bonus: 33800,
    departmentId: 200
  },
  {
    employeeId: 110,
    firstName: 'Dollie',
    lastName: 'Pittman',
    revenue: 15700,
    targetComplete: 40,
    targetIncomplete: 60,
    rating: 3,
    status: 'Approved',
    salary: 121000,
    bonus: 60600,
    departmentId: 500
  },
  {
    employeeId: 120,
    firstName: 'Leticia',
    lastName: 'Goodman',
    revenue: 16200,
    targetComplete: 80,
    targetIncomplete: 20,
    rating: 5,
    status: 'Pending',
    salary: 295000,
    bonus: 74900,
    departmentId: 300
  },
  {
    employeeId: 130,
    firstName: 'Harrison',
    lastName: 'Jarvis',
    revenue: 32500,
    targetComplete: 30,
    targetIncomplete: 70,
    rating: 1,
    status: 'Pending',
    salary: 125000,
    bonus: 59600,
    departmentId: 80
  },
  {
    employeeId: 140,
    firstName: 'Salinas',
    lastName: 'Richardson',
    revenue: 49600,
    targetComplete: 80,
    targetIncomplete: 20,
    rating: 5,
    status: 'Pending',
    salary: 228000,
    bonus: 50500,
    departmentId: 50
  },
  {
    employeeId: 150,
    firstName: 'Barry',
    lastName: 'Maxwell',
    revenue: 42800,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 5,
    status: 'Pending',
    salary: 269000,
    bonus: 52200,
    departmentId: 400
  },
  {
    employeeId: 160,
    firstName: 'Diaz',
    lastName: 'Velazquez',
    revenue: 24100,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 4,
    status: 'Approved',
    salary: 242000,
    bonus: 45000,
    departmentId: 370
  },
  {
    employeeId: 170,
    firstName: 'Minnie',
    lastName: 'Riley',
    revenue: 12000,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 2,
    status: 'Approved',
    salary: 107000,
    bonus: 67500,
    departmentId: 250
  },
  {
    employeeId: 180,
    firstName: 'Fulton',
    lastName: 'Bernard',
    revenue: 29400,
    targetComplete: 80,
    targetIncomplete: 20,
    rating: 4,
    status: 'Approved',
    salary: 259000,
    bonus: 37400,
    departmentId: 170
  },
  {
    employeeId: 190,
    firstName: 'Chandler',
    lastName: 'Mccarty',
    revenue: 30100,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 1,
    status: 'Approved',
    salary: 185000,
    bonus: 74000,
    departmentId: 250
  },
  {
    employeeId: 200,
    firstName: 'Flowers',
    lastName: 'Hernandez',
    revenue: 20700,
    targetComplete: 70,
    targetIncomplete: 30,
    rating: 4,
    status: 'Approved',
    salary: 135000,
    bonus: 39300,
    departmentId: 260
  },
  {
    employeeId: 210,
    firstName: 'Donaldson',
    lastName: 'Sharp',
    revenue: 42300,
    targetComplete: 70,
    targetIncomplete: 30,
    rating: 3,
    status: 'Pending',
    salary: 176000,
    bonus: 67600,
    departmentId: 250
  },
  {
    employeeId: 220,
    firstName: 'Melanie',
    lastName: 'Gamble',
    revenue: 30100,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 3,
    status: 'Approved',
    salary: 219000,
    bonus: 52400,
    departmentId: 230
  },
  {
    employeeId: 230,
    firstName: 'Leona',
    lastName: 'Erickson',
    revenue: 11400,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 1,
    status: 'Pending',
    salary: 185000,
    bonus: 57300,
    departmentId: 160
  },
  {
    employeeId: 240,
    firstName: 'Dionne',
    lastName: 'Howell',
    revenue: 44200,
    targetComplete: 90,
    targetIncomplete: 10,
    rating: 1,
    status: 'Approved',
    salary: 211000,
    bonus: 65800,
    departmentId: 130
  },
  {
    employeeId: 250,
    firstName: 'June',
    lastName: 'Warren',
    revenue: 39500,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 3,
    status: 'Approved',
    salary: 222000,
    bonus: 65200,
    departmentId: 260
  },
  {
    employeeId: 260,
    firstName: 'Carey',
    lastName: 'Johns',
    revenue: 36000,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 4,
    status: 'Approved',
    salary: 233000,
    bonus: 69500,
    departmentId: 190
  },
  {
    employeeId: 270,
    firstName: 'Estelle',
    lastName: 'Bowers',
    revenue: 27600,
    targetComplete: 40,
    targetIncomplete: 60,
    rating: 2,
    status: 'Approved',
    salary: 212000,
    bonus: 37700,
    departmentId: 120
  },
  {
    employeeId: 280,
    firstName: 'Rena',
    lastName: 'Blanchard',
    revenue: 16000,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 4,
    status: 'Approved',
    salary: 135000,
    bonus: 51000,
    departmentId: 380
  },
  {
    employeeId: 290,
    firstName: 'Hinton',
    lastName: 'Tillman',
    revenue: 42400,
    targetComplete: 80,
    targetIncomplete: 20,
    rating: 4,
    status: 'Pending',
    salary: 134000,
    bonus: 49600,
    departmentId: 40
  },
  {
    employeeId: 300,
    firstName: 'Gloria',
    lastName: 'Everett',
    revenue: 42100,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 3,
    status: 'Approved',
    salary: 278000,
    bonus: 38400,
    departmentId: 180
  },
  {
    employeeId: 310,
    firstName: 'Ware',
    lastName: 'Simon',
    revenue: 49500,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 3,
    status: 'Approved',
    salary: 142000,
    bonus: 43900,
    departmentId: 190
  },
  {
    employeeId: 320,
    firstName: 'Carolina',
    lastName: 'Holmes',
    revenue: 22700,
    targetComplete: 80,
    targetIncomplete: 20,
    rating: 4,
    status: 'Pending',
    salary: 181000,
    bonus: 52000,
    departmentId: 320
  },
  {
    employeeId: 330,
    firstName: 'Day',
    lastName: 'Newman',
    revenue: 46000,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 5,
    status: 'Approved',
    salary: 117000,
    bonus: 66700,
    departmentId: 290
  },
  {
    employeeId: 340,
    firstName: 'Nielsen',
    lastName: 'Harrell',
    revenue: 13800,
    targetComplete: 30,
    targetIncomplete: 70,
    rating: 5,
    status: 'Pending',
    salary: 212000,
    bonus: 39600,
    departmentId: 70
  },
  {
    employeeId: 350,
    firstName: 'Barbara',
    lastName: 'Moore',
    revenue: 37600,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 4,
    status: 'Pending',
    salary: 185000,
    bonus: 61800,
    departmentId: 340
  },
  {
    employeeId: 360,
    firstName: 'Reese',
    lastName: 'Green',
    revenue: 27500,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 4,
    status: 'Approved',
    salary: 168000,
    bonus: 72500,
    departmentId: 30
  },
  {
    employeeId: 370,
    firstName: 'Paige',
    lastName: 'Gregory',
    revenue: 22300,
    targetComplete: 70,
    targetIncomplete: 30,
    rating: 3,
    status: 'Pending',
    salary: 270000,
    bonus: 33500,
    departmentId: 360
  },
  {
    employeeId: 380,
    firstName: 'Jaclyn',
    lastName: 'Mann',
    revenue: 29700,
    targetComplete: 40,
    targetIncomplete: 60,
    rating: 1,
    status: 'Approved',
    salary: 224000,
    bonus: 76400,
    departmentId: 120
  },
  {
    employeeId: 390,
    firstName: 'Lula',
    lastName: 'Fowler',
    revenue: 40700,
    targetComplete: 60,
    targetIncomplete: 40,
    rating: 3,
    status: 'Approved',
    salary: 211000,
    bonus: 57000,
    departmentId: 320
  },
  {
    employeeId: 400,
    firstName: 'Regina',
    lastName: 'Watson',
    revenue: 10600,
    targetComplete: 50,
    targetIncomplete: 50,
    rating: 3,
    status: 'Pending',
    salary: 211000,
    bonus: 31600,
    departmentId: 470
  },
  {
    employeeId: 410,
    firstName: 'Candice',
    lastName: 'Hardin',
    revenue: 48200,
    targetComplete: 90,
    targetIncomplete: 10,
    rating: 4,
    status: 'Pending',
    salary: 191000,
    bonus: 73400,
    departmentId: 110
  },
  {
    employeeId: 420,
    firstName: 'Pate',
    lastName: 'Haney',
    revenue: 12600,
    targetComplete: 90,
    targetIncomplete: 10,
    rating: 2,
    status: 'Approved',
    salary: 247000,
    bonus: 71600,
    departmentId: 200
  },
  {
    employeeId: 430,
    firstName: 'Snider',
    lastName: 'Shepard',
    revenue: 30900,
    targetComplete: 30,
    targetIncomplete: 70,
    rating: 4,
    status: 'Pending',
    salary: 230000,
    bonus: 59200,
    departmentId: 20
  },
  {
    employeeId: 440,
    firstName: 'Fleming',
    lastName: 'Torres',
    revenue: 13500,
    targetComplete: 40,
    targetIncomplete: 60,
    rating: 5,
    status: 'Approved',
    salary: 111000,
    bonus: 69800,
    departmentId: 120
  },
  {
    employeeId: 450,
    firstName: 'Terrie',
    lastName: 'Grimes',
    revenue: 47200,
    targetComplete: 40,
    targetIncomplete: 60,
    rating: 4,
    status: 'Pending',
    salary: 118000,
    bonus: 42900,
    departmentId: 460
  },
  {
    employeeId: 460,
    firstName: 'Hallie',
    lastName: 'Frye',
    revenue: 20900,
    targetComplete: 60,
    targetIncomplete: 40,
    rating: 4,
    status: 'Approved',
    salary: 218000,
    bonus: 50000,
    departmentId: 340
  },
  {
    employeeId: 470,
    firstName: 'Jerry',
    lastName: 'Salazar',
    revenue: 43300,
    targetComplete: 90,
    targetIncomplete: 10,
    rating: 5,
    status: 'Approved',
    salary: 103000,
    bonus: 49800,
    departmentId: 440
  },
  {
    employeeId: 480,
    firstName: 'Sally',
    lastName: 'Barnett',
    revenue: 39500,
    targetComplete: 30,
    targetIncomplete: 70,
    rating: 3,
    status: 'Pending',
    salary: 132000,
    bonus: 80000,
    departmentId: 160
  },
  {
    employeeId: 490,
    firstName: 'Goldie',
    lastName: 'Kelly',
    revenue: 32600,
    targetComplete: 20,
    targetIncomplete: 80,
    rating: 5,
    status: 'Approved',
    salary: 102000,
    bonus: 39000,
    departmentId: 10
  },
  {
    employeeId: 500,
    firstName: 'Brianna',
    lastName: 'Compton',
    revenue: 30400,
    targetComplete: 60,
    targetIncomplete: 40,
    rating: 4,
    status: 'Pending',
    salary: 114000,
    bonus: 78200,
    departmentId: 280
  }
];
